import {
  ADD_EMPLOYEE_SUCCESS,
  ADD_EMPLOYEE_FAIL,
  GET_STAFF_SUCCESS,
  GET_STAFF_FAIL,
  DELETE_STAFF_FAIL,
  DELETE_STAFF_SUCCESS,
  GET_STAFF_BY_ID_FAIL,
  GET_STAFF_BY_ID_SUCCESS,
  UPDATE_EMPLOYEE_FAIL,
  UPDATE_EMPLOYEE_SUCCESS,
  GET_STAFF_BY_EMAIL,
  GET_STAFF_BY_EMAIL_SUCCESS,
  GET_STAFF_BY_EMAIL_FAIL,
  GET_STAFF_CALENDER_FAIL,
  GET_STAFF_CALENDER_SUCCESS,
  POST_STAFF_DOC_SUCCESS,
  POST_STAFF_DOC_FAIL,
  STAFF_STATE_FAIL,
  STAFF_STATE_SUCCESS,
  GET_EMPLOYEE_PROFILE_DOCS_FAIL,
  GET_EMPLOYEE_PROFILE_DOCS_SUCCESS,
  APPROVE_EMP_DOCS_FAIL,
  APPROVE_EMP_DOCS_SUCCESS,
  NOTIFY_EMPLOYEE_FAIL,
  NOTIFY_EMPLOYEE_SUCCESS,
  EMPLOYEES_EXPIRE_DOCS_LIST_FAIL,
  EMPLOYEES_EXPIRE_DOCS_LIST_SUCCESS,
  AVAILABILITY_SUCCESS,
  AVAILABILITY_FAIL,
  DELETE_STAFF_DOC_SUCCESS,
  DELETE_STAFF_DOC_FAIL,
  COPY_EMPLOYEE_PROFILE_SUCCESS,
  COPY_EMPLOYEE_PROFILE_FAIL,
  GENERATE_TIME_SHEET_SUCCESS,
  GENERATE_TIME_SHEET_FAIL,
  GET_ADMIN_TIMESHEET_LIST_SUCCESS,
  GET_ADMIN_TIMESHEET_LIST_FAIL,
  SEND_TIME_SHEET_TO_SUPPORT_WORKER_SUCCESS,
  SEND_TIME_SHEET_TO_SUPPORT_WORKER_FAIL,
  RE_SUBMIT_TIME_SHEET_SUCCESS,
  RE_SUBMIT_TIME_SHEET_FAIL,
  REMOVE_TIME_SHEET_SUCCESS,
  REMOVE_TIME_SHEET_FAIL,
  APPROVE_EMP_VEHICLE_DOCS_SUCCESS,
  APPROVE_EMP_VEHICLE_DOCS_FAIL,
  GET_EMPLOYEE_RATING_REPORT_SUCCESS,
  GET_EMPLOYEE_RATING_REPORT_FAIL,
  DELETE_TRAINING_DOC_SUCCESS,
  DELETE_TRAINING_DOC_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  userData: [],
  deletUser: [],
  staffDetail: [],
  succRes: [],
  error: [],
  staffCalData: [],
  staffDocRes: [],
  empState: [],
  empProfileRes: [],
  approvalState: [],
  notifyRes: [],
  expDocsList: [],
  availabilityList: [],
  list: [],
};

const Staff = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EMPLOYEE_RATING_REPORT_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };
    case GET_EMPLOYEE_RATING_REPORT_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case REMOVE_TIME_SHEET_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };
    case REMOVE_TIME_SHEET_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case RE_SUBMIT_TIME_SHEET_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };
    case RE_SUBMIT_TIME_SHEET_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SEND_TIME_SHEET_TO_SUPPORT_WORKER_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };
    case SEND_TIME_SHEET_TO_SUPPORT_WORKER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_ADMIN_TIMESHEET_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case GET_ADMIN_TIMESHEET_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case COPY_EMPLOYEE_PROFILE_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };
    case COPY_EMPLOYEE_PROFILE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GENERATE_TIME_SHEET_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case GENERATE_TIME_SHEET_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_STAFF_DOC_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };
    case DELETE_STAFF_DOC_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case AVAILABILITY_SUCCESS:
      return {
        ...state,
        availabilityList: action.payload,
      };
    case AVAILABILITY_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_STAFF_BY_EMAIL:
      return {
        ...state,
        staffData: [],
        succRes: [],
      };
    case EMPLOYEES_EXPIRE_DOCS_LIST_SUCCESS:
      return {
        ...state,
        expDocsList: action.payload,
      };

    case EMPLOYEES_EXPIRE_DOCS_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case NOTIFY_EMPLOYEE_SUCCESS:
      return {
        ...state,
        notifyRes: action.payload,
      };

    case NOTIFY_EMPLOYEE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case APPROVE_EMP_DOCS_SUCCESS:
      return {
        ...state,
        approvalState: action.payload,
      };

    case APPROVE_EMP_DOCS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case APPROVE_EMP_VEHICLE_DOCS_SUCCESS:
      return {
        ...state,
        approvalState: action.payload,
      };

    case APPROVE_EMP_VEHICLE_DOCS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_EMPLOYEE_PROFILE_DOCS_SUCCESS:
      return {
        ...state,
        empProfileRes: action.payload,
      };

    case GET_EMPLOYEE_PROFILE_DOCS_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case STAFF_STATE_SUCCESS:
      return {
        ...state,
        empState: action.payload,
      };

    case STAFF_STATE_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_STAFF_BY_EMAIL_SUCCESS:
      return {
        ...state,
        staffData: action.payload,
      };

    case GET_STAFF_BY_EMAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case POST_STAFF_DOC_SUCCESS:
      return {
        ...state,
        staffDocRes: action.payload,
      };

    case POST_STAFF_DOC_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_STAFF_CALENDER_SUCCESS:
      return {
        ...state,
        staffCalData: action.payload,
      };

    case GET_STAFF_CALENDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_EMPLOYEE_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };

    case UPDATE_EMPLOYEE_FAIL:
      return {
        ...state,
        error: action.paload,
      };

    case GET_STAFF_BY_ID_SUCCESS:
      return {
        ...state,
        staffDetail: action.payload,
      };

    case GET_STAFF_BY_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_STAFF_SUCCESS:
      return {
        ...state,
        userData: action.payload,
      };

    case GET_STAFF_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_EMPLOYEE_SUCCESS:
      return {
        ...state,
        succRes: action.payload,
      };

    case ADD_EMPLOYEE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_STAFF_SUCCESS:
      return {
        ...state,
        deletUser: action.payload,
      };

    case DELETE_STAFF_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case DELETE_TRAINING_DOC_SUCCESS:
      return {
        ...state,
        trainingLinksDocuments: action.payload,
      };
    case DELETE_TRAINING_DOC_FAIL:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
};

export default Staff;
